import { handleUnauthorized } from "./authsession";

export const authenticatedFetch = async (url, options = {}) => {

    const response = await fetch(url, {
        ...options,
        credentials: "include"
    });

    if (response.status === 401) {
        handleUnauthorized();
        return null;
    }
    
    if (response.status === 403) {
        handleUnauthorized();
        return null;
    }

    return response;
};